document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.wishbook').forEach(initWishbook);
});

function initWishbook(root) {
  var handles = [root.getAttribute('data-collection-handle'), root.getAttribute('data-collection-2-handle')].filter(Boolean);
  var wantsMore = root.getAttribute('data-load-all') === 'true' && handles.length && window.fetch && !window.WISHBOOK_DEMO;
  if (!wantsMore) { buildBook(root); return; }
  var bk = root.querySelector('.wishbook__book');
  if (bk) { bk.innerHTML = '<p class="wishbook__loading">Opening the catalog&hellip;</p>'; }
  var done = false;
  function go() { if (done) return; done = true; buildBook(root); }
  setTimeout(go, 8000);
  wishbookLoadMore(root, handles).then(go, go);
}

function wishbookFormatMoney(price, format) {
  var cents = Math.round(parseFloat(price) * 100);
  if (!isFinite(cents)) return '';
  function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  var whole = Math.floor(cents / 100);
  var dec = ('0' + (cents % 100)).slice(-2);
  var out = format || '${{amount}}';
  return out.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
    if (name === 'amount') return group(whole, ',') + '.' + dec;
    if (name === 'amount_no_decimals') return group(Math.round(cents / 100), ',');
    if (name === 'amount_with_comma_separator') return group(whole, '.') + ',' + dec;
    if (name === 'amount_no_decimals_with_comma_separator') return group(Math.round(cents / 100), '.');
    if (name === 'amount_with_apostrophe_separator') return group(whole, "'") + '.' + dec;
    return group(whole, ',') + '.' + dec;
  });
}

function wishbookLoadMore(root, handles) {
  var max = parseInt(root.getAttribute('data-max-products'), 10) || 100;
  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 3;
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var preorderTag = root.getAttribute('data-preorder-tag') || 'preorder';
  var soonTag = root.getAttribute('data-coming-soon-tag') || 'coming-soon';
  var shipBy = root.getAttribute('data-ship-by') || '';
  var arrival = root.getAttribute('data-arrival') || '';
  var waitPrompt = root.getAttribute('data-waitlist-prompt') || 'Not here yet. Leave your email and we will tell you the moment it arrives.';
  var waitThanks = root.getAttribute('data-waitlist-thanks') || 'You are on the list. We will email you when it lands.';

  var sourceList = root.querySelector('.wishbook__pages-source');
  var qsData = root.querySelector('.wishbook__qs-data');
  if (!sourceList) return Promise.resolve();

  var firstPage = sourceList.querySelector('.wishbook__product-page');
  var existing = Array.prototype.slice.call(sourceList.querySelectorAll('.wishbook__item'));
  var seen = {};
  existing.forEach(function (it) { seen[it.getAttribute('data-wishbook-id')] = true; });
  var added = [];

  function fetchHandle(handle, page) {
    if (existing.length + added.length >= max) return Promise.resolve();
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('collection fetch failed'); return r.json(); })
      .then(function (data) {
        var list = (data && data.products) || [];
        for (var i = 0; i < list.length; i++) {
          if (existing.length + added.length >= max) return;
          if (seen[list[i].id]) continue;
          seen[list[i].id] = true;
          added.push(list[i]);
        }
        if (list.length === 250) return fetchHandle(handle, page + 1);
      });
  }

  var chain = Promise.resolve();
  handles.forEach(function (h) { chain = chain.then(function () { return fetchHandle(h, 1); }); });

  function img(src, w) {
    if (!src) return null;
    return src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + w + 'x$1$2');
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function hasTag(p, tag) {
    var t = p.tags;
    if (typeof t === 'string') t = t.split(',').map(function (x) { return x.trim(); });
    return (t || []).indexOf(tag) !== -1;
  }

  function buildItem(p) {
    var variants = p.variants || [];
    var single = variants.length === 1 && variants[0].title === 'Default Title';
    var soon = hasTag(p, soonTag);
    var pre = !soon && hasTag(p, preorderTag);
    var available = variants.some(function (v) { return v.available !== false; });
    var minP = Infinity, maxP = 0;
    variants.forEach(function (v) { var n = parseFloat(v.price); if (n < minP) minP = n; if (n > maxP) maxP = n; });

    var art = el('article', 'wishbook__item');
    art.setAttribute('data-wishbook-id', p.id);

    if (soon) art.appendChild(el('span', 'wishbook__preorder-badge wishbook__badge--soon', 'Coming soon' + (arrival ? ' \u00B7 ' + arrival : '')));
    else if (pre) art.appendChild(el('span', 'wishbook__preorder-badge', 'Preorder' + (shipBy ? ' \u00B7 Ships ' + shipBy : '')));

    var imgSrc = (p.image && p.image.src) || (p.images && p.images[0] && p.images[0].src);
    if (imgSrc) {
      var im = el('img', 'wishbook__item-photo');
      im.src = img(imgSrc, 400);
      im.alt = (p.image && p.image.alt) || p.title || '';
      im.loading = 'lazy';
      im.width = 400; im.height = 400;
      art.appendChild(im);
    }

    var body = el('div', 'wishbook__item-body');
    body.appendChild(el('p', 'wishbook__item-name', p.title));
    var tmp = document.createElement('div');
    tmp.innerHTML = p.body_html || '';
    var blurb = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    if (blurb.length > 90) blurb = blurb.slice(0, 87).replace(/\s+\S*$/, '') + '...';
    body.appendChild(el('p', 'wishbook__item-blurb', blurb));

    if (soon) {
      var wl = el('div', 'wishbook__waitlist');
      wl.appendChild(el('p', 'wishbook__waitlist-note', waitPrompt));
      var f = document.createElement('form');
      f.method = 'post'; f.action = '/contact#contact_form';
      f.className = 'wishbook__waitlist-form';
      f.setAttribute('data-wishbook-waitlist', '');
      function hid(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
      hid('form_type', 'customer'); hid('utf8', '\u2713');
      hid('contact[tags]', 'waitlist, waitlist-' + p.handle);
      hid('contact[accepts_marketing]', 'true');
      var lab = el('label', 'visually-hidden', 'Email address'); lab.setAttribute('for', 'wl-email-' + p.id); f.appendChild(lab);
      var em = document.createElement('input');
      em.type = 'email'; em.id = 'wl-email-' + p.id; em.name = 'contact[email]'; em.className = 'wishbook__waitlist-input';
      em.placeholder = 'name@example.com'; em.autocomplete = 'email'; em.required = true;
      f.appendChild(em);
      var sb = el('button', 'wishbook__cta', 'Notify me'); sb.type = 'submit'; f.appendChild(sb);
      var th = el('p', 'wishbook__waitlist-thanks', waitThanks); th.setAttribute('role', 'status'); th.hidden = true; f.appendChild(th);
      var er = el('p', 'wishbook__waitlist-error', 'That did not go through. Check your email address and try again.'); er.setAttribute('role', 'alert'); er.hidden = true; f.appendChild(er);
      wl.appendChild(f);
      body.appendChild(wl);
    } else if (!single) {
      var foot = el('div', 'wishbook__item-footer');
      foot.appendChild(el('span', 'wishbook__price', (minP !== maxP ? 'From ' : '') + wishbookFormatMoney(minP, moneyFormat)));
      var qb = el('button', 'wishbook__cta', available ? 'Choose options' : 'Sold out');
      qb.type = 'button';
      qb.setAttribute('data-wishbook-quickshop', p.id);
      qb.setAttribute('aria-haspopup', 'dialog');
      if (!available) qb.disabled = true;
      foot.appendChild(qb);
      body.appendChild(foot);

      if (qsData) {
        var data = {
          id: p.id, title: p.title, url: '/products/' + p.handle, preorder: pre,
          options: (p.options || []).map(function (o) { return o.name; }),
          image: img(imgSrc, 600) || null,
          variants: variants.map(function (v) {
            var cmp = parseFloat(v.compare_at_price);
            return {
              id: v.id,
              options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
              available: v.available !== false,
              price: wishbookFormatMoney(v.price, moneyFormat),
              compare: cmp > parseFloat(v.price) ? wishbookFormatMoney(v.compare_at_price, moneyFormat) : null,
              image: (v.featured_image && v.featured_image.src) ? img(v.featured_image.src, 600) : null
            };
          })
        };
        var sc = document.createElement('script');
        sc.type = 'application/json';
        sc.setAttribute('data-wishbook-product', p.id);
        sc.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
        qsData.appendChild(sc);
      }
    } else {
      var foot2 = el('div', 'wishbook__item-footer');
      var price = el('span', 'wishbook__price');
      var cmp2 = parseFloat(variants[0] && variants[0].compare_at_price);
      if (cmp2 > parseFloat(variants[0].price)) price.appendChild(el('s', null, wishbookFormatMoney(variants[0].compare_at_price, moneyFormat)));
      price.appendChild(document.createTextNode((price.firstChild ? ' ' : '') + wishbookFormatMoney(variants[0] ? variants[0].price : 0, moneyFormat)));
      foot2.appendChild(price);
      var cf = document.createElement('form');
      cf.method = 'post'; cf.action = '/cart/add'; cf.acceptCharset = 'UTF-8';
      var idIn = document.createElement('input'); idIn.type = 'hidden'; idIn.name = 'id'; idIn.value = variants[0] ? variants[0].id : ''; cf.appendChild(idIn);
      var cb = el('button', 'wishbook__cta', pre ? 'Preorder now' : 'Add to cart');
      cb.type = 'submit'; cb.setAttribute('data-wishbook-preorder', '');
      if (!available) cb.disabled = true;
      cf.appendChild(cb);
      foot2.appendChild(cf);
      body.appendChild(foot2);
    }
    art.appendChild(body);
    return art;
  }

  return chain.then(function () {
    if (!added.length) return;
    var all = existing.concat(added.map(buildItem));
    var parent = firstPage ? firstPage.parentNode : sourceList;
    var anchor = firstPage ? firstPage : null;
    Array.prototype.slice.call(sourceList.querySelectorAll('.wishbook__product-page')).forEach(function (pg) {
      if (pg !== anchor) pg.parentNode.removeChild(pg);
    });
    var pageClass = firstPage ? firstPage.className : 'wishbook__page-inner wishbook__product-page';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < all.length; i += perPage) {
      var pg = document.createElement('div');
      pg.className = pageClass;
      for (var j = i; j < Math.min(i + perPage, all.length); j++) pg.appendChild(all[j]);
      frag.appendChild(pg);
    }
    if (anchor) { parent.insertBefore(frag, anchor); parent.removeChild(anchor); }
    else sourceList.insertBefore(frag, sourceList.children[3] || null);
  });
}

function buildBook(root) {
  var book = root.querySelector('.wishbook__book');
  var sourceList = root.querySelector('.wishbook__pages-source');
  if (!book || !sourceList) return;
  book.innerHTML = '';

  var pages = Array.prototype.slice.call(sourceList.children);
  if (pages.length === 0) return;

  // On phones each page is narrow, so give every product its own page (readable, no clipped text).
  if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) {
    var regrouped = [];
    pages.forEach(function (pg) {
      var items = pg.classList.contains('wishbook__product-page')
        ? Array.prototype.slice.call(pg.querySelectorAll(':scope > .wishbook__item'))
        : [];
      if (items.length < 2) { regrouped.push(pg); return; }
      items.forEach(function (it) {
        var np = document.createElement('div');
        np.className = pg.className;
        np.appendChild(it);
        regrouped.push(np);
      });
    });
    pages = regrouped;
  }

  var backEnd = null;
  var backCover = null;
  pages.forEach(function (p) {
    var role = p.getAttribute('data-wishbook-role');
    if (role === 'back-endpaper') backEnd = p;
    if (role === 'back-cover') backCover = p;
  });

  if (backEnd && backCover) {
    pages = pages.filter(function (p) { return p !== backEnd && p !== backCover; });
    if (pages.length % 2 === 1) {
      var notes = document.createElement('div');
      notes.className = 'wishbook__page-inner wishbook__letter wishbook__notes';
      notes.innerHTML = '<h3>Wishes and notes</h3><div class="wishbook__notes-lines"></div>';
      pages.push(notes);
    }
    pages.push(backEnd, backCover);
  }

  function addFace(sheet, className, page) {
    var face = document.createElement('div');
    face.className = 'wishbook__face ' + className;
    if (page.classList.contains('wishbook__cover')) face.classList.add('is-cover');
    face.appendChild(page);
    sheet.appendChild(face);
  }

  var sheets = [];
  for (var i = 0; i < pages.length; i += 2) {
    var sheet = document.createElement('div');
    sheet.className = 'wishbook__sheet';

    addFace(sheet, 'front', pages[i]);

    var backPage = pages[i + 1];
    if (!backPage) {
      backPage = document.createElement('div');
      backPage.className = 'wishbook__page-inner';
    }
    addFace(sheet, 'back', backPage);

    book.appendChild(sheet);
    sheets.push(sheet);
  }

  sheets.forEach(function (sh, idx) {
    if (idx > 0 && idx < sheets.length - 1) sh.classList.add('is-inner');
    if (idx === sheets.length - 1) sh.classList.add('is-last');
  });

  var spine = document.createElement('div');
  spine.className = 'wishbook__spine';
  book.appendChild(spine);

  var current = 0;
  var total = sheets.length;

  var prevBtn = root.querySelector('[data-wishbook-prev]');
  var nextBtn = root.querySelector('[data-wishbook-next]');
  var status = root.querySelector('[data-wishbook-status]');

  var coverBtn = root.querySelector('[data-wishbook-cover]');
  var clearTimer = null;
  var hideTimer = null;
  var hasRendered = false;

  // iOS Safari memory fix: only keep sheets near the open spread as live 3D layers
  function nearCurrent(i, lo, hi) {
    if (lo !== null && i >= lo && i < hi) return true;
    return i >= current - 2 && i < current + 2;
  }
  function cullSheets() {
    sheets.forEach(function (sheet, i) {
      sheet.style.display = nearCurrent(i, null, null) ? '' : 'none';
    });
  }

  function render(fromIdx) {
    var lo = null, hi = null;
    if (typeof fromIdx === 'number' && Math.abs(fromIdx - current) > 1) {
      lo = Math.min(fromIdx, current);
      hi = Math.max(fromIdx, current);
      var n = hi - lo;
      var step = Math.min(90, 700 / n);
      var forward = current > fromIdx;
      sheets.forEach(function (sheet, i) {
        if (i >= lo && i < hi) {
          var k = forward ? i - lo : hi - 1 - i;
          sheet.style.transitionDelay = Math.round(k * step) + 'ms';
        }
      });
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () {
        sheets.forEach(function (sheet) { sheet.style.transitionDelay = ''; });
      }, 1200 + Math.round(n * step));
    }
    sheets.forEach(function (sheet, i) {
      if (sheet.style.display === 'none' && nearCurrent(i, lo, hi)) {
        sheet.style.display = '';
        void sheet.offsetWidth;
      }
      sheet.classList.toggle('is-flipped', i < current);
      sheet.style.zIndex = i < current ? i : total - i;
    });
    clearTimeout(hideTimer);
    if (!hasRendered) {
      hasRendered = true;
      cullSheets();
    } else {
      hideTimer = setTimeout(cullSheets, lo !== null ? 1300 + Math.round((hi - lo) * step) : 1100);
    }
    if (coverBtn) coverBtn.disabled = current === 0;
    var bb = root.querySelector('[data-wishbook-back-cover]');
    if (bb) bb.disabled = current === total;
    book.classList.toggle('is-closed-front', current === 0);
    book.classList.toggle('is-closed-back', current === total);
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total;
    if (status) {
      status.textContent = current === 0
        ? 'Cover'
        : current === total
          ? 'Back cover'
          : 'Spread ' + current + ' of ' + (total - 1);
    }
  }

  var sound = initSound(root);

  function next() {
    if (current < total) {
      current += 1;
      render();
      sound.turn();
    }
  }

  function prev() {
    if (current > 0) {
      current -= 1;
      render();
      sound.turn();
    }
  }

  function goTo(target) {
    target = Math.max(0, Math.min(total, target));
    if (target === current) return;
    var from = current;
    current = target;
    render(from);
    sound.turn(Math.min(3, Math.abs(target - from)));
  }

  if (coverBtn) coverBtn.addEventListener('click', function () { goTo(0); });

  var backBtn = root.querySelector('[data-wishbook-back-cover]');
  if (backBtn) backBtn.addEventListener('click', function () { goTo(total); });

  if (nextBtn) nextBtn.addEventListener('click', next);
  if (prevBtn) prevBtn.addEventListener('click', prev);

  sheets.forEach(function (sheet, i) {
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('form, input, button, a')) return;
      if (i === current) next();
      else if (i === current - 1) prev();
    });
  });

  root.addEventListener('keydown', function (e) {
    if (e.target.closest('input, textarea')) return;
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });

  var touchStartX = null;
  book.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  book.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (dx < -40) next();
    if (dx > 40) prev();
    touchStartX = null;
  });

  root.querySelectorAll('[data-wishbook-preorder]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var form = btn.closest('form');
      if (form && window.fetch) {
        var formData = new FormData(form);
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            btn.disabled = false;
          });
      }
    });
  });

  initSnow(root);

  initQuickShop(root);
  render();
}

document.addEventListener('submit', function (e) {
  var form = e.target.closest ? e.target.closest('[data-wishbook-waitlist]') : null;
  if (!form || !(window.fetch || window.WISHBOOK_DEMO)) return;
  e.preventDefault();

  var btn = form.querySelector('button[type="submit"]');
  var thanks = form.querySelector('.wishbook__waitlist-thanks');
  var error = form.querySelector('.wishbook__waitlist-error');
  var original = btn.textContent;

  error.hidden = true;
  btn.disabled = true;
  btn.textContent = 'Saving…';

  (window.WISHBOOK_DEMO ? Promise.resolve({ ok: true }) : fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' }))
    .then(function (res) {
      if (!res.ok) throw new Error('Waitlist signup failed');
      Array.prototype.forEach.call(form.querySelectorAll('input, button'), function (el) {
        if (el.type !== 'hidden') el.hidden = true;
      });
      thanks.hidden = false;
    })
    .catch(function () {
      error.hidden = false;
      btn.disabled = false;
      btn.textContent = original;
    });
});

function initQuickShop(root) {
  var panel = root.querySelector('[data-wishbook-qs]');
  if (!panel) return;

  var card = panel.querySelector('.wishbook__qs-card');
  var imgEl = panel.querySelector('[data-qs-image]');
  var titleEl = panel.querySelector('[data-qs-title]');
  var priceEl = panel.querySelector('[data-qs-price]');
  var optsEl = panel.querySelector('[data-qs-options]');
  var msgEl = panel.querySelector('[data-qs-msg]');
  var addBtn = panel.querySelector('[data-qs-add]');
  var detailsEl = panel.querySelector('[data-qs-details]');

  var products = {};
  Array.prototype.forEach.call(root.querySelectorAll('script[data-wishbook-product]'), function (el) {
    try {
      var p = JSON.parse(el.textContent);
      products[p.id] = p;
    } catch (err) {}
  });

  var product = null;
  var selected = [];
  var trigger = null;
  var basePrice = '';

  function matches(variant, skipIndex) {
    for (var i = 0; i < selected.length; i++) {
      if (i === skipIndex || selected[i] === null) continue;
      if (variant.options[i] !== selected[i]) return false;
    }
    return true;
  }

  function currentVariant() {
    if (selected.indexOf(null) !== -1) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (matches(product.variants[i], -1)) return product.variants[i];
    }
    return null;
  }

  function valueAvailable(optIndex, value) {
    return product.variants.some(function (v) {
      return v.options[optIndex] === value && v.available && matches(v, optIndex);
    });
  }

  function uniqueValues(optIndex) {
    var out = [];
    product.variants.forEach(function (v) {
      if (out.indexOf(v.options[optIndex]) === -1) out.push(v.options[optIndex]);
    });
    return out;
  }

  function choose(optIndex, value) {
    selected[optIndex] = value;
    var anyMatch = product.variants.some(function (v) {
      return v.available && matches(v, -1);
    });
    if (!anyMatch) {
      for (var j = 0; j < selected.length; j++) {
        if (j !== optIndex) selected[j] = null;
      }
    }
    msgEl.textContent = '';
    update();
  }

  function renderOptions() {
    optsEl.innerHTML = '';
    product.options.forEach(function (name, i) {
      var group = document.createElement('div');
      group.className = 'wishbook__qs-group';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', name);

      var label = document.createElement('p');
      label.className = 'wishbook__qs-label';
      label.textContent = name;
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'wishbook__qs-values';
      uniqueValues(i).forEach(function (value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wishbook__qs-value';
        b.textContent = value;
        b.setAttribute('role', 'radio');
        b.setAttribute('data-opt', i);
        b.setAttribute('data-val', value);
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          choose(i, value);
          var again = optsEl.querySelector('[data-opt="' + i + '"][data-val="' + value.replace(/"/g, '\\"') + '"]');
          if (again) again.focus();
        });
        row.appendChild(b);
      });
      group.appendChild(row);
      optsEl.appendChild(group);
    });
  }

  function update() {
    Array.prototype.forEach.call(optsEl.querySelectorAll('.wishbook__qs-value'), function (b) {
      var i = parseInt(b.getAttribute('data-opt'), 10);
      var value = b.getAttribute('data-val');
      var isSel = selected[i] === value;
      var ok = valueAvailable(i, value);
      var anywhere = product.variants.some(function (v) {
        return v.options[i] === value && v.available;
      });
      b.setAttribute('aria-checked', isSel ? 'true' : 'false');
      b.setAttribute('aria-disabled', anywhere ? 'false' : 'true');
      b.classList.toggle('is-selected', isSel);
      b.classList.toggle('is-soldout', !ok);
    });

    var variant = currentVariant();
    if (variant) {
      priceEl.innerHTML = variant.compare ? '<s></s> ' : '';
      if (variant.compare) priceEl.querySelector('s').textContent = variant.compare;
      priceEl.appendChild(document.createTextNode(variant.price));
      imgEl.src = variant.image || product.image || '';
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? (product.preorder ? 'Preorder now' : 'Add to cart') : 'Sold out';
    } else {
      priceEl.textContent = basePrice;
      imgEl.src = product.image || '';
      var nextIdx = selected.indexOf(null);
      var nextName = nextIdx === -1 ? '' : product.options[nextIdx].toLowerCase();
      addBtn.disabled = true;
      addBtn.textContent = nextName ? 'Select a ' + nextName : 'Unavailable';
    }
  }

  function focusables() {
    return Array.prototype.filter.call(
      card.querySelectorAll('button, a[href]'),
      function (el) { return !el.disabled && el.getAttribute('aria-disabled') !== 'true'; }
    );
  }

  function open(p, btn) {
    product = p;
    trigger = btn;
    selected = product.options.map(function (name, i) {
      var vals = uniqueValues(i);
      return vals.length === 1 ? vals[0] : null;
    });
    var priceNode = btn.parentNode.querySelector('.wishbook__price');
    basePrice = priceNode ? priceNode.textContent.replace(/\s+/g, ' ').trim() : '';
    titleEl.textContent = product.title;
    imgEl.alt = product.title;
    detailsEl.href = product.url || '#';
    msgEl.textContent = '';
    renderOptions();
    update();
    panel.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    card.focus();
  }

  function close() {
    panel.hidden = true;
    document.documentElement.style.overflow = '';
    if (trigger) trigger.focus();
  }

  function addToCart() {
    var variant = currentVariant();
    if (!variant || !variant.available) return;
    var original = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    var request = window.WISHBOOK_DEMO
      ? Promise.resolve()
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        }).then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        });

    request.then(function () {
      var btn = trigger;
      var label = btn ? btn.textContent : '';
      close();
      if (btn) {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = label; }, 2200);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {
      msgEl.textContent = 'That did not go through. Try again.';
      addBtn.disabled = false;
      addBtn.textContent = original;
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishbook-quickshop]') : null;
    if (!btn) return;
    e.stopPropagation();
    var p = products[btn.getAttribute('data-wishbook-quickshop')];
    if (p) open(p, btn);
  });

  panel.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishbook-qs-close]')) close();
  });

  addBtn.addEventListener('click', addToCart);

  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      close();
    } else if (e.key === 'Tab') {
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    e.stopPropagation();
  });
}

function initSound(root) {
  var btn = root.querySelector('[data-wishbook-sound]');
  var musicUrl = root.getAttribute('data-music-url') || '';
  var turnUrl = root.getAttribute('data-turn-url') || '';
  var AC = window.AudioContext || window.webkitAudioContext;
  var noop = { turn: function () {} };
  if (!AC && !musicUrl && !turnUrl) {
    if (btn) btn.hidden = true;
    return noop;
  }
  if (!btn) return noop;

  var on = false;
  var ctx = null;
  var master = null;
  var timer = null;
  var nextTime = 0;
  var bar = 0;
  var musicEl = null;
  var turnEl = null;
  var noiseBuf = null;

  var BAR = 2.9;
  var chords = [
    [261.63, 329.63, 392.0],
    [220.0, 261.63, 329.63],
    [174.61, 220.0, 261.63],
    [196.0, 246.94, 293.66]
  ];
  var tunes = [
    [784.0, 0, 659.25, 0, 783.99, 0, 1046.5, 0],
    [880.0, 0, 783.99, 0, 659.25, 0, 783.99, 0],
    [698.46, 0, 880.0, 0, 1046.5, 0, 880.0, 0],
    [783.99, 0, 987.77, 0, 1174.66, 0, 783.99, 0]
  ];

  function ensureCtx() {
    if (ctx || !AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0.35;
    master.connect(ctx.destination);
  }

  function bell(freq, t, vol, len) {
    var o1 = ctx.createOscillator();
    var o2 = ctx.createOscillator();
    var g = ctx.createGain();
    o1.type = 'sine';
    o2.type = 'sine';
    o1.frequency.value = freq;
    o2.frequency.value = freq * 2.76;
    var g2 = ctx.createGain();
    g2.gain.value = 0.18;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(vol, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t + len);
    o1.connect(g);
    o2.connect(g2);
    g2.connect(g);
    g.connect(master);
    o1.start(t);
    o2.start(t);
    o1.stop(t + len + 0.05);
    o2.stop(t + len + 0.05);
  }

  function scheduleBar(t) {
    var chord = chords[bar % chords.length];
    var tune = tunes[bar % tunes.length];
    var step = BAR / 8;
    for (var i = 0; i < 6; i++) {
      bell(chord[i % 3] / 2, t + i * (BAR / 6), 0.07, 1.6);
    }
    for (var j = 0; j < 8; j++) {
      if (tune[j]) bell(tune[j], t + j * step, 0.09, 1.1);
    }
    bar += 1;
  }

  function tick() {
    while (nextTime < ctx.currentTime + 1.5) {
      scheduleBar(nextTime);
      nextTime += BAR;
    }
  }

  function startMusic() {
    if (musicUrl) {
      if (!musicEl) {
        musicEl = new Audio(musicUrl);
        musicEl.loop = true;
        musicEl.volume = 0.3;
      }
      var p = musicEl.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }
    ensureCtx();
    if (!ctx) return;
    if (ctx.resume) ctx.resume();
    nextTime = ctx.currentTime + 0.15;
    tick();
    timer = setInterval(tick, 400);
  }

  function stopMusic() {
    if (musicEl) musicEl.pause();
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (ctx && ctx.suspend) ctx.suspend();
  }

  function turn(count) {
    var reps = count && count > 1 ? count : 1;
    for (var r = 1; r < reps; r++) setTimeout(turnOnce, r * 140);
    turnOnce();
  }

  function turnOnce() {
    if (turnUrl) {
      if (!turnEl) {
        turnEl = new Audio(turnUrl);
        turnEl.preload = 'auto';
      }
      var a = turnEl.cloneNode();
      a.volume = 0.7;
      var p = a.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }
    ensureCtx();
    if (!ctx) return;
    if (ctx.resume) ctx.resume();
    if (!noiseBuf) {
      var samples = wishbookPageTurnSamples(ctx.sampleRate);
      noiseBuf = ctx.createBuffer(1, samples.length, ctx.sampleRate);
      noiseBuf.getChannelData(0).set(samples);
    }
    var src = ctx.createBufferSource();
    src.buffer = noiseBuf;
    src.playbackRate.value = 0.94 + Math.random() * 0.12;
    var g = ctx.createGain();
    g.gain.value = 0.9;
    src.connect(g);
    g.connect(master);
    src.start(ctx.currentTime);
  }

  function setOn(value) {
    on = value;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.textContent = on ? 'Music on' : 'Music off';
    if (on) {
      if (turnUrl && !turnEl) {
        turnEl = new Audio(turnUrl);
        turnEl.preload = 'auto';
      }
      ensureCtx();
      startMusic();
    } else {
      stopMusic();
    }
  }

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    setOn(!on);
  });

  document.addEventListener('visibilitychange', function () {
    if (!on) return;
    if (document.hidden) stopMusic();
    else startMusic();
  });

  btn.textContent = 'Music off';
  btn.setAttribute('aria-pressed', 'false');

  return { turn: turn };
}

function wishbookPageTurnSamples(sr) {
  var len = Math.floor(sr * 0.8);
  var out = new Float32Array(len);
  var seed = 20261225;
  function rnd() {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    return seed / 4294967296;
  }
  function coef(fc) { return 1 - Math.exp(-2 * Math.PI * fc / sr); }

  var hi = coef(5200), lo = coef(650), rumble = coef(180);
  var lpHi = 0, lpLo = 0, lpRumble = 0;
  var grain = 0;
  var grainDecay = Math.exp(-1 / (0.005 * sr));
  var landAt = 0.57;

  for (var i = 0; i < len; i++) {
    var t = i / sr;
    var n = rnd() * 2 - 1;

    lpHi += hi * (n - lpHi);
    lpLo += lo * (n - lpLo);
    lpRumble += rumble * (n - lpRumble);
    var band = lpHi - lpLo;

    var v = 0;

    var lift = Math.exp(-t / 0.03);
    v += lpRumble * 5 * lift * 1.2;

    if (t > 0.03 && t < 0.6) {
      var x = (t - 0.03) / 0.57;
      var env = Math.pow(Math.sin(Math.PI * Math.pow(x, 0.8)), 1.4);
      if (rnd() < 0.0022) grain = 0.5 + 0.5 * rnd();
      grain *= grainDecay;
      v += band * 5.5 * env * (0.12 + grain * 1.1);
    }

    if (t >= landAt) {
      var d = t - landAt;
      v += Math.sin(2 * Math.PI * 88 * d) * Math.exp(-d / 0.045) * 1.3;
      v += lpRumble * 6 * Math.exp(-d / 0.03) * 1.0;
    }

    out[i] = v;
  }

  var peak = 0;
  for (var k = 0; k < len; k++) peak = Math.max(peak, Math.abs(out[k]));
  var scale = peak > 0 ? 0.9 / peak : 1;
  var fade = Math.floor(sr * 0.02);
  for (var m = 0; m < len; m++) {
    out[m] *= scale;
    if (m > len - fade) out[m] *= (len - m) / fade;
  }
  return out;
}

function initSnow(root) {
  var layer = root.querySelector('.wishbook__snow');
  if (!layer || root.getAttribute('data-snow') === 'false') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var count = root.clientWidth < 640 ? 34 : 70;

  function setFall() {
    layer.style.setProperty('--wb-fall', (root.offsetHeight + 40) + 'px');
  }
  setFall();

  for (var i = 0; i < count; i++) {
    var size = 2 + Math.random() * 4.5;
    var dur = 15 - size * 1.4 + Math.random() * 6;
    var flake = document.createElement('span');
    flake.style.left = (Math.random() * 100) + '%';
    flake.style.width = size + 'px';
    flake.style.height = size + 'px';
    flake.style.animationDuration = dur + 's';
    flake.style.animationDelay = '-' + (Math.random() * dur) + 's';
    flake.style.opacity = (0.35 + Math.random() * 0.55) + '';
    flake.style.setProperty('--sway-x', (8 + Math.random() * 20) + 'px');
    flake.style.setProperty('--sway-t', (3 + Math.random() * 3.5) + 's');
    if (size > 5) flake.style.filter = 'blur(1px)';
    layer.appendChild(flake);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setFall, 200);
  });
}